<template>
  <div>
    <div class="btn-sm-drop statusbtn" v-show="fromList && !showDropdown" @click="toggleDropdown">
        <button class="btn btn-secondary m-md-2">{{ currentStatus }} <span>▼</span></button>
    </div>
      <b-dropdown
        v-if="showDropdown || !fromList"
        id='ddown1' 
        :text="currentStatus + '▼'"
        class='btn-sm-drop statusbtn m-md-2'
        @hidden="$emit('hidden')"
        @shown="$emit('shown')"
        ref="bDropdown"
      >
        <b-dropdown-item
        v-for='(status, index) in client_status'
        v-bind:key='index'
        v-on:click='changeStatus(status)'
        :disabled="toggledisabledstatus">
        {{status}} 
        </b-dropdown-item>
      </b-dropdown>
  </div>
</template>
<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations } from 'vuex';

export default {
  name: 'Dropdown',
  props: ['applicant', 'toggledisabledstatus','isReviewer','fromList'],
  data() {
    return {
      showDropdown: false,
    };
  },
  computed: {
    currentStatus() {
      return this.applicant.new_status || this.applicant.status;
    },
    client_status() {
      return this.$store.getters.getClientStatus;
    },
  },
  methods: {
    ...mapMutations({
      mutateApplicantsAfterStatus: 'mutateApplicantsAfterStatus',
    }),
    toggleDropdown() {
      this.showDropdown = true;
      this.$nextTick(() => {
        if (this.$refs.bDropdown) {
          this.$refs.bDropdown.show(); // Open the dropdown first
          this.$nextTick(() => {
            this.$refs.bDropdown.$el.blur(); // Remove focus after opening
          });
        }
      });
    },

    hideDropdown() {
      this.showDropdown = false;
      this.$emit('hidden');
    },
    changeStatus(status) {
      // this.current_status = 'loading... ';
      ApiService.put(Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id), {
        status,
        isNewPanel: true,
      })// eslint-disable-next-line
        .then(({ data }) => {
          // this.current_status = status;
          this.$emit('statusChanged', data.data);
          // setTimeout(()=>{
          this.mutateApplicantsAfterStatus(data.data,this.isReviewer);
          // },1500)
          this.showDropdown = false;
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
  },
};
</script>
<style scoped>
::v-deep .dropdown-toggle::after {
  display: none !important;
}

.statusbtn button {
  transition: background-color 0.2s, border-color 0.2s;
}

.statusbtn button:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
  color: #3c3c3c !important; /* Ensure text remains visible/readable on light gray */
}

</style>

